"use client"

import * as React from "react"
// import { MoonIcon, SunIcon } from "@radix-ui/react-icons"
import { appConfig } from "@/lib/appConfig";
import { usePathname } from "@/lib/i18n";
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/components/ui/dropdown-menu"


import {
  LanguagesIcon
} from "lucide-react";

import { useLocale } from "next-intl";
import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";
import { SmartText } from "@/components/ui/SmartFont";

export function LocaleButton() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentLocale = useLocale();
  const [locale, setLocale] = useState<string>(currentLocale);
  const { locales, localeLabels } = appConfig.i18n;

  // 处理语言切换，确保路径正确
  const handleLocaleChange = (newLocale: string) => {
    setLocale(newLocale);
    
    // 直接构建正确的路径，不重复添加语言前缀
    const path = `/${newLocale}${pathname}`;
    const query = searchParams.toString();
    const url = query ? `${path}?${query}` : path;
    
    router.replace(url);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm">
          <LanguagesIcon className="size-4" />
          <span className="sr-only">Change language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="font-sans opacity-90">
      <DropdownMenuRadioGroup
                value={locale}
                onValueChange={handleLocaleChange}
              >
                {locales.map((locale) => {
                  return (
                    <DropdownMenuRadioItem key={locale} value={locale}>
                      <SmartText>
                        {locale in localeLabels
                          ? localeLabels[locale]
                          : locale}
                      </SmartText>
                    </DropdownMenuRadioItem>
                  );
                })}
              </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
